import UNIQUE from '@/common/unique'

export default {
  id: 'embed',
  name: 'embed',
  type: 'standard',
  moduleName: 'editor_module_embed',
  dataSet: {
    mods: 'embed',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'embed',
        value: ''
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'padding'
      ]
    },
    action: null,
    detail: null
  }
}
